export default __webpack_public_path__ + "static/media/smiley.ed4a4ce0.svg";